import Cookies from 'js-cookie';

export default function prepareQuery(query = {}) {
  const isTestRequest = Cookies.get('virtualCardsTest');

  return isTestRequest
    ? {
        ...query,
        virtualCardsTest: true,
      }
    : query;
}
